import NoticeModal from './NoticeModal';

export default NoticeModal;
